import { useEffect } from 'react';
import { useData } from '../context/DataContext';

export function useCacheCheck() {
  const { checkAndRefreshCache } = useData();
  
  useEffect(() => {
    checkAndRefreshCache();
  }, [checkAndRefreshCache]);
} 